import { useOrgSettings } from './useOrgSettings';
import { useMembers } from './useTeam';
import { teacherColor } from '../lib/teacherDisplay';

/** Whether teacher-assignment UI should be shown (org setting, default true). */
export function useShowTeacher(): boolean {
  const { data } = useOrgSettings();
  return data?.settings?.showTeacherAssignment ?? true;
}

/** Members mapped to teacher options for pickers/filters. */
export function useTeacherOptions(): { id: string; name: string; color: string }[] {
  const { data: members } = useMembers();
  return (members ?? []).map((m) => ({ id: m.id, name: m.user.fullName || m.user.email, color: teacherColor(m.id) }));
}
